var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomBooking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 31,
    height: 31,
    rx: 6,
    fill: "#DBE5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48312 16.8502V12.1627C9.48312 11.8382 9.22008 11.5752 8.89563 11.5752C8.57115 11.5752 8.30811 11.8382 8.30811 12.1627V19.8377C8.30811 20.1622 8.57115 20.4252 8.89563 20.4252C9.22008 20.4252 9.48312 20.1622 9.48312 19.8377V18.737L21.517 18.7087V19.8094C21.517 20.1339 21.78 20.3969 22.1045 20.3969C22.4289 20.3969 22.692 20.1339 22.692 19.8094V18.7087V17.1719V16.8219L9.48312 16.8502Z",
    fill: "#2966FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.692 16.3467H13.7607V14.1342C13.7607 13.4921 14.2812 12.9717 14.9232 12.9717H20.3451C21.6413 12.9717 22.692 14.0224 22.692 15.3185V16.3467Z",
    fill: "#2966FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6701 16.0942C12.4623 16.0942 13.1044 15.452 13.1044 14.6599C13.1044 13.8677 12.4623 13.2256 11.6701 13.2256C10.878 13.2256 10.2358 13.8677 10.2358 14.6599C10.2358 15.452 10.878 16.0942 11.6701 16.0942Z",
    fill: "#2966FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomBooking);
export default __webpack_public_path__ + "static/media/room_booking.50c286026825105cf7882f2f5d5b8839.svg";
export { ForwardRef as ReactComponent };